<template>
    <div :data-testid="props.dataTestid + '-container'">
        <TsCard noShadow noBorder :data-testid="props.dataTestid + '-card'">
        <TsTypography as="h5" :data-testid="props.dataTestid + '-title'">{{ props.title }}</TsTypography>
        <TsTypography append-class="my-2" :data-testid="props.dataTestid + '-description'">{{ props.description }}</TsTypography>

        <button
            @click="handleIsOpen"
            :class="twMerge('text-primary cursor-pointer', isOpen && 'mb-4')">
          {{ isOpen ? 'View Less' : 'View More' }}
        </button>
        <template v-if="isOpen && props.tablesData.length > 0">
            <div v-for="tableData in props.tablesData" class="my-4">
                <TsTableCookieStatement :data="tableData" />
            </div>
        </template>
    </TsCard>
    </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from "vue";
import { useRandomUUID } from "~/composables/useRandomUUID";
import { twMerge } from "tailwind-merge";

const TsCard = defineAsyncComponent(
    () => import('~/components/organisms/TsCard.vue')
);

const TsTableCookieStatement = defineAsyncComponent(
    () => import('~/components/organisms/TsTableCookieStatement.vue')
);

type Props = {
    title?: string;
    description?: string;
    tablesData?: any[];
    dataTestid?: string;
};

const props = withDefaults(defineProps<Props>(), {
    title: "Functional Cookies",
    description: "These cookies are necessary for the proper functioning of our website, such as filling a shopping cart, completing a form or chatting directly with one of our employees.",
    tablesData: [
        {
            title: 'Toolstation Cookies',
            header: [{ label: 'Cookie' }, { label: 'Goal' }, { label: 'Retention' }],
            body: [
                {
                    cookie: '.Toolstation',
                    goal: 'This cookie registers which items you place in your shopping cart.',
                    retention: '120 months',
                },
                {
                    cookie: 'Mktopt and mktpref',
                    goal: 'Saves your cookie preference.',
                    retention: '6 months',
                },
                {
                    cookie: 'toolstation_session',
                    goal: 'This cookie stores session related information.',
                    retention: '3 days',
                },
                {
                    cookie: '_br_uid_2',
                    goal: 'This cookie is used to allow users to share pages through third party social networking sites.',
                    retention: '12 months',
                },
            ],
        },
    ]
});

const isOpen = ref(false);

const handleIsOpen = () => {
  isOpen.value = !isOpen.value
}

const randomId = ref<string>("");

onMounted(() => {
    if (import.meta.client) randomId.value = useRandomUUID();
});
</script>